import Widget1 from '@/views/contracts/contract-card/widgets/widget-1.vue';
import ContractResponisblePersons from '@/views/contracts/contract-card/widgets/contract-responsible-persons.vue';
import WidgetNotebook from '@/views/contracts/contract-card/widgets/widget-notebook.vue';

import { markRaw } from 'vue';
import WidgetContractUserAttributes from '@/views/contracts/contract-card/widgets/widget-contract-user-attributes.vue';

const list = [
    {
        name: 'Ответственные за договор',
        caption: ['ndog'],
        icon: '/infoenergo/assets/widget_responsible_persons.svg',
        component: ContractResponisblePersons,
    },
    {
        name: 'Записная книжка',
        caption: ['ndog'],
        icon: '/infoenergo/assets/widget_notebook.svg',
        component: WidgetNotebook,
    },
    {
        name: 'История корректировок',
        caption: ['ndog'],
        icon: '/infoenergo/assets/widget_quote_history.svg',
        component: Widget1,
    },
    {
        name: 'Дополнительные документы',
        caption: ['ndog'],
        icon: '/infoenergo/assets/widget_additional_documents.svg',
        component: Widget1,
    },
    {
        name: 'Пользовательские атрибуты',
        caption: ['ndog'],
        icon: '/infoenergo/assets/widget_additional_documents.svg',
        width: '40vw',
        height: '50vh',
        component: WidgetContractUserAttributes,
    },
];

const useContractWidgetList = () => {
    return list.map(widget => {
        const { component, ...rest } = widget;
        return {
            ...rest,
            id: 'widget-' + Math.floor(Math.random() * Date.now()).toString(),
            visible: false,
            component: markRaw(component),
        };
    });
};

export default useContractWidgetList;
